var _rect, _rect2, _rect3, _rect4, _rect5, _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 91,
    viewBox: "0 0 141 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 130,
    height: 75,
    rx: 3,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 1,
    width: 2,
    height: 74,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 1,
    width: 21,
    height: 74,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 26.6152,
    width: 23.494,
    height: 21.3855,
    rx: 3,
    fill: "#8D4DC9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 56.2051,
    y: 35.1543,
    width: 17.1901,
    height: 17.1901,
    transform: "rotate(-45 56.2051 35.1543)",
    fill: "url(#pattern0)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 119.5,
    cy: 69.5,
    r: 21.5,
    fill: "#E9706D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.095 80H124.259V75.7959H127.174V73.0127H124.259V58.8623H119.586C116.671 63.2422 113.565 68.2373 110.782 73.0127V75.7959H121.095V80ZM113.932 73.0713V72.8662C116.1 69.1602 118.678 65.0439 120.948 61.6309H121.139V73.0713H113.932Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1574_24075",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1574_24075",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADFElEQVR4nO3dO2gUQRzH8fFRKBLxKiP4ABtBwdK3Vla2akDElFoKFgraWdkIRjBiYyHY2FoqinhYXasW5mIrCupZ+EhyfGVlluwdRC7G3fnPzO/TpQmz+7vd393u7KxzIiIiIiIiIiIiiQE2AmeBK8AEsD70mLIFHAM+Mqj4+zqwOfT4sgJsAb6ytJ/AfWBv6LFmAbjG6J4AJ4BVocedLOAhy/cGOK+eqQHwiH9XnOqmgK11jC1LKwyk9Mv/n32htyd6/ymQqjZwGlgTetuiVEMgpXfARWBD6G2MSo2BDPfMttDbGoUGAhnumf2ht9m0BgOpUs8YC6Q0o56xFUipp56xFUhpzo/ngMuVsUCq8uwZw4GUuln1TASBDPfMdpeyiAIpLQCPgYMuRREGUtUBJoG1LhWRB1LtmWIuwCYXu0QCSadnEguk1Pc9c8jFJtFA4u2ZDAIpzUbRMxkFUvrme2aHsyjDQIZ75rCzJONAbPaMP3xlsGdaIQM56Qcjg79nbgbpmWJaKPC0MhhZNB/k/gywDrgNfK4MRga9avz+TFFqwG7gOHDOn09v+U/JS3/N6Dt5ew9cKp6ncVYUk6yBncAR/6kpbiDdAB74GfKv/Xk49d8z94BdLhbFtxVgjz/iJv0RN+WPuLY/4n4Qf8/cNXXErBRpBPcix/v/LePBTYTeRyYRruPuhN52k1Agje3olvFT1imXAuzv6FE8B1Y7yxLZ0aN87Z0GxkLuaP0wpIEfhv6ali6dhL504j/x037VBgl5cdFffn+2xCByN9/45Xefuhi6QVXcB5HFfgh+C1eTHLA1ySHXQPqaBmSDJsoZMauppDZ0zPRDxh3S1+MINvT0wI4N3Sj6IYNTVieqfkg0kAU9Fm1DL/p+SOQI6WppDRvaWnwmvDktz2TjlNXTAmY2OmQmq34YhRbBNEbLxBqjhZSN0VLjxmgxfmP0ugpj9EKXNF559Ba4oFce1QC4uowg9FKwugHjwJe/hKDX5jUNOAp8GArik3+x5HjjA5I/oYwBZ4DLevWqiIiIiIiIiIiIy95vxuredaOZs6IAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4);
export default __webpack_public_path__ + "static/media/step_4.7f60e167a38dc8c3b0ab4b771345b486.svg";
export { ForwardRef as ReactComponent };